// ============================================================================
//  COACH CONFIGURATION — the single source of truth for all brand copy.
// ============================================================================

export const coach = {
  firstName: "Harjap",
  lastName: "",
  fullName: "Harjap",
  businessName: "FitnessBySilverback",
  logoTop: "FITNESS BY",
  logoBottom: "SILVERBACK",

  tagline: "Online fitness coaching",
  email: "sbackfitness@gmail.com",

  // Local physique photography (Harjap)
  images: {
    hero: "/coach/harjap-header.png",     // full front physique — face upper area
    about: "/coach/harjap-5.webp",        // double-bicep portrait
    whatYouGet: "/coach/harjap-4.webp",   // training / barbell curl
    band: "/coach/harjap-2.webp",         // side bicep physique
  },

  hero: {
    badge: "Now Accepting Clients",
    // Kinetic headline — each string is one masked line
    headline: ["BUILD THE", "PHYSIQUE", "YOU ACTUALLY", "WANT."],
    sub: "1-on-1 online coaching for men who are done guessing. Custom training, nutrition and real accountability — built around your life.",
    primaryCta: "Apply for Coaching",
    secondaryCta: "My Story",
  },

  // First-person positioning for FitnessBySilverback
  about: {
    kicker: "The Story",
    heading: "BUILT THROUGH CONSISTENCY.",
    paragraphs: [
      "Building a physique you're proud of isn't about chasing shortcuts. It's about having the right plan and executing it consistently.",
      "Training taught me that real progress comes from structure — knowing what to train, how to progress, what to eat, and when to make adjustments.",
      "That's the same approach behind FitnessBySilverback. No random workouts. No unnecessary complexity. No plan that expects your entire life to revolve around fitness.",
      "Just structured training, realistic nutrition, accountability and a clear strategy built around your goals.",
    ],
    signature: "— Harjap",
    gallery: [
      { label: "Everyday Grind", src: "/coach/harjap-2.webp", pos: "50% 18%" },
      { label: "The Work", src: "/coach/harjap-4.webp", pos: "50% 22%" },
    ],
  },

  whatYouGet: {
    kicker: "The System",
    heading: "WHAT YOU GET",
    sub: "Everything you need to stop guessing and start progressing — nothing you don't.",
    features: [
      { icon: "Dumbbell", title: "Custom Training", desc: "A personalized program built around your goals, experience, schedule and equipment." },
      { icon: "Utensils", title: "Personalized Nutrition", desc: "A realistic nutrition strategy designed around your lifestyle and goals." },
      { icon: "CalendarCheck", title: "Weekly Check-Ins", desc: "Regular progress reviews and adjustments based on your actual progress." },
      { icon: "MessageCircle", title: "Direct Coach Access", desc: "Support from Harjap between check-ins for questions and guidance." },
      { icon: "Video", title: "Form Feedback", desc: "Exercise technique feedback to improve the quality of every session." },
      { icon: "TrendingUp", title: "Progressive Adjustments", desc: "Training and nutrition evolve as you progress — so you never stall." },
    ],
  },

  marquee: ["DISCIPLINE", "CONSISTENCY", "STRUCTURE", "ACCOUNTABILITY", "PATIENCE", "PROGRESS"],

  results: {
    kicker: "Real Clients",
    heading: "REAL RESULTS.",
    sub: "Real clients. Real work. Structured training, nutrition and accountability — here's the proof.",
    // Real before/after transformation pairs (drag-to-compare sliders).
    clients: [
      { before: "/coach/t1-before.jpg", beforePos: "50% 30%", after: "/coach/t1-after.webp", afterPos: "50% 24%" },
      { before: "/coach/t2-before.jpg", beforePos: "58% 42%", after: "/coach/t2-after.webp", afterPos: "60% 44%" },
      { before: "/coach/t3-before.webp", beforePos: "50% 24%", after: "/coach/t3-after.webp", afterPos: "50% 20%" },
      { before: "/coach/t4-before.jpg", beforePos: "42% 30%", after: "/coach/t4-after.webp", afterPos: "72% 26%" },
      { before: "/coach/t5-before.png", beforePos: "50% 30%", after: "/coach/t5-after.png", afterPos: "50% 28%" },
    ],
  },

  contact: {
    kicker: "Get In Touch",
    heading: "READY TO START?",
    sub: "Take three minutes to apply. If we're a good fit, you'll hear from Harjap personally.",
  },

  pageTitle: "FitnessBySilverback | Online Fitness Coaching",
  metaDescription:
    "FitnessBySilverback offers personalized 1-on-1 online fitness coaching with custom training, nutrition guidance and accountability designed to help you build muscle, lose fat and transform your physique.",
  og: {
    title: "FitnessBySilverback | Online Fitness Coaching",
    description:
      "Personalized 1-on-1 online fitness coaching built around your schedule and goals. Now accepting clients.",
  },
};

export default coach;
